<template>
	<div>
		<ModalBank ref="ModalBank" @save="saveData"></ModalBank>
		<modalconfirm ref="modalConfirm" @action="confirmDelete"/>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Bank</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-btn light depressed class="primary" @click="tambah()">
						<v-icon>mdi-plus-circle</v-icon>
						<div class="pl-2 text-capitalize">Tambah Bank</div>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listBank" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationBank.total_data" class="table-w-50">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="update(item)" class="mr-1" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn @click="deleteData(item)" class="mr-1" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on">
								<v-icon dark>mdi-delete</v-icon>
							</v-btn>
						</template>
						<span>Hapus</span>
					</v-tooltip>
				</template>
				<template v-slot:item.bank_is_active="{ item }">
					<v-switch v-model="item.bank_is_active" @change="editStatus(item)" true-value="1" false-value="0"></v-switch>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationBank">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationBank">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationBank.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationBank.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalBank from './components/ModalBank'
import modalconfirm from '@/components/ModalConfirm'

const list_status = [{
	value: 1,
	text: 'Aktif'
}, {
	value: 0,
	text: 'Tidak Aktif'
}];

export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalBank, modalconfirm
	},
	data() {
		return {
			bank_id: '',
			type: '',
			sortBy: 'bank_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', value: 'action'},
			{ text: 'Nama Bank', align: 'start', value: 'bank_name'},
			{ text: 'Status', value: 'bank_is_active'},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Nama Bank',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'bank_name'
				}
			}, {
				type: 'selection',
				label: 'Status',
				item: list_status,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'bank_is_active'
				}
			},
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceBank', ['listBank', 'paginationBank']),
	},
	methods: {
		...mapActions('ecommerceBank', ['getBank', 'exportBank', 'addBank', 'updateBank', 'deleteBank']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceBank', ['clearDataBank']),

		getData() {
			this.getBank(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData() {
			this.exportBank(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		async editStatus(data) {
			await this.updateBank({
				id: data.bank_id,
				name: data.bank_name,
				is_active: data.bank_is_active
			})
			await this.getData()
		},
		async tambah() {
			await this.$refs.ModalBank.defineParams({
				bank_id: '',
				bank_name: '',
				bank_is_active: '1',
			})
			this.type = 'add'
			await this.$refs.ModalBank.showModal()
		},
		async update(data) {
			this.type = 'update'
			await this.$refs.ModalBank.defineParams(data)
			await this.$refs.ModalBank.showModal()
		},
		async saveData(data) {
			if (this.type == 'add')
				await this.addBank(data)
			else if (this.type == 'update')
				await this.updateBank(data)
			await this.getData()
			await this.$refs.ModalBank.hideModal()
		},
		async deleteData(data) {
			let msg = `Apakah anda yakin ingin menghapus data ${data.bank_name}?`
			this.bank_id = data.bank_id
			this.$refs.modalConfirm.setMessage(msg)
			this.$refs.modalConfirm.showConfirm()
		},
		async confirmDelete() {
			await this.deleteBank({
				id: this.bank_id
			})
			await this.getData()
			await this.$refs.modalConfirm.hideConfirm()
		}
	},
	beforeDestroy(){
		this.clearDataBank()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Bank Ecommerce`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>

<style>
